import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LANDING_GOTO_BACK = (
    <FormattedMessage
        id='landing.goto.back'
        defaultMessage='К ОПИСАНИЮ'
    />
)

export const LANDING_GOTO_BATTLE = (
    <FormattedMessage
        id='landing.goto.battle'
        defaultMessage='Стать легионером'
    />
)

export const LANDING_GOTO_BATTLE_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.battle.tooltip'
        defaultMessage='Перейти к подбору отряда для участия в клановых боях в роли легионера'
    />
)

export const LANDING_GOTO_CREATE_CLAN = (
    <FormattedMessage
        id='landing.goto.create.clan'
        defaultMessage='Создать клан'
    />
)

export const LANDING_GOTO_CREATE_CLAN_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.create.clan.tooltip'
        defaultMessage='Перейти на клановый портал для создания клана'
    />
)

export const LANDING_GOTO_INVITATIONS = (
    <FormattedMessage
        id='landing.goto.invitations'
        defaultMessage='Приглашения в клан'
    />
)

export const LANDING_GOTO_INVITATIONS_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.invitations.tooltip'
        defaultMessage='Перейти к приглашениям в клан'
    />
)

export const LANDING_GOTO_SELECTION_CLAN = (
    <FormattedMessage
        id='landing.goto.selection.clan'
        defaultMessage='К подбору клана'
    />
)

export const LANDING_GOTO_SELECTION_CLAN_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.selection.clan.tooltip'
        defaultMessage='Перейти к подбору клана'
    />
)

export const LANDING_PROMO_AWARD_HEADER = (
    <FormattedMessage
        id='landing_promo.award_header'
        defaultMessage='Уникальный стиль для клановых игроков'
    />
)

export const LANDING_PROMO_AWARD_MESSAGE = (
    <FormattedMessage
        id='landing_promo.award_message'
        // eslint-disable-next-line max-len
        defaultMessage='Каждый игрок, находящийся в клане, получает уникальный стиль «Клановый повседневный», который можно установить на машину любого уровня.'
    />
)

export const LANDING_GOTO_GLOBAL_MAP_EVENT_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.global_map_event.tooltip'
        defaultMessage='Перейти к событию'
    />
)

export const LANDING_GOTO_MANEUVERS_EVENT_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.maneuvers_event.tooltip'
        defaultMessage='Перейти к событию'
    />
)

export const LANDING_GOTO_MANEUVERS_EVENT = (
    <FormattedMessage
        id='landing.goto.maneuvers_event'
        defaultMessage='Манёвры'
    />
)

export const LANDING_GOTO_CLAN_SUPPLY = (
    <FormattedMessage
        id='landing.goto.clan_supply'
        defaultMessage='Боевой поход'
    />
)

export const LANDING_GOTO_CLAN_SUPPLY_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.clan_supply.tooltip'
        defaultMessage='Перейти к боевому походу'
    />
)

export const LANDING_GOTO_CLAN_SUPPLY_IS_DISABLED_TOOLTIP = (
    <FormattedMessage
        id='landing.goto.clan_supply.is_disabled.tooltip'
        defaultMessage='Прогресс боевого похода приостановлен'
    />
)



// WEBPACK FOOTER //
// ./containers/Landing/translations.js